<template>
  <pt-sell-operate-choice-dialog class="pt-sell-operate-choice-dialog__page"></pt-sell-operate-choice-dialog>
</template>

<script>
import PtSellOperateChoiceDialog from 'cps/adult-sell-order/pt-adult-sell-order/pt-sell-operate-choice-dialog/withData'
export default {
  name: 'pt-sell-operate-choice-dialog__view',
  components: {
    'pt-sell-operate-choice-dialog': PtSellOperateChoiceDialog
  }
}
</script>
